import { mapStateToPropsUserType } from './connectUserType';
import { selectors } from 'state/selectors';
import { renderPropsConnect } from '../renderPropsConnect';

export { IsInternal } from './IsInternal';
export { IsInternalSales } from './IsInternalSales';

export const UserType = renderPropsConnect(mapStateToPropsUserType(selectors));
